export enum StatusActivationType {
  immediately = 0,
  onDate = 1,
  afterTimeInterval = 2,
  relativeDate = 3,
  formula = 4,
}

export enum StatusActivationEventType {
  dateOfAward      = 0,
  dateOfExpiration = 1,
}